import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SUBDOMAIN_BROKER_MAP = {
  'vantage': '/vantage-markets',
  'vantagemarkets': '/vantage-markets',
  'icmarkets': '/ic-markets',
  'roboforex': '/roboforex',
  'xm': '/xm',
  'puprime': '/pu-prime',
};

export function useSubdomainRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Check if we're on a subdomain (e.g., vantage.marketsreview.org)
    // Must have at least 3 parts and not be 'www'
    if (parts.length >= 3) {
      const subdomain = parts[0].toLowerCase();
      if (subdomain !== 'www' && subdomain !== 'api') {
        const brokerPath = SUBDOMAIN_BROKER_MAP[subdomain];
        if (brokerPath && location.pathname === '/') {
          navigate(brokerPath, { replace: true });
        }
      }
    }
  }, [navigate, location.pathname]);
}
